// 共通の多言語化設定ファイル

// 選択可能な言語コードの型
export type SupportedLanguageCode = 'ja' | 'en_US'

// 言語コード定数
export const LANGUAGE_CODES = {
  JAPANESE: 'ja',
  ENGLISH: 'en_US',
} as const

// デフォルトの言語コード
export const DEFAULT_LANGUAGE_CODE: SupportedLanguageCode = LANGUAGE_CODES.JAPANESE

// 言語コードの型定義
export type LanguageCode = typeof LANGUAGE_CODES[keyof typeof LANGUAGE_CODES]

// 汎用的な翻訳データ取得ヘルパー関数
export const getTranslation = <T extends { langCode: string }>(
  translations: T[] | undefined,
  selectedLanguageCode: LanguageCode
): T | undefined => {
  return translations?.find(t => t.langCode === selectedLanguageCode)
}

// 汎用的な翻訳データ更新ヘルパー関数
export const updateTranslation = <T extends { langCode: string }>(
  translations: T[],
  langCode: string,
  updates: Partial<Omit<T, 'langCode'>>
): T[] => {
  const existingIndex = translations.findIndex(t => t.langCode === langCode)
  
  if (existingIndex >= 0) {
    // 既存の翻訳を更新
    return translations.map((t, index) => 
      index === existingIndex ? { ...t, ...updates } : t
    )
  } else {
    // 新しい翻訳を追加
    return [...translations, { langCode, ...updates } as T]
  }
}